import type { UserRole } from '@kfolks/types'

const roleBadgeColors: Record<string, string> = {
	SUPER_ADMIN: 'bg-red-100 text-red-800',
	ADMIN: 'bg-indigo-100 text-indigo-800',
	USER: 'bg-green-100 text-green-800',
	VIEWER: 'bg-gray-100 text-gray-800',
}

interface WelcomeHeaderProps {
	displayName: string
	role: UserRole | string
}

/**
 * Renders the dashboard's top-of-page welcome line — `Welcome, {displayName}`
 * + a role-keyed coloured pill. Visible to every authenticated role
 * (Spec 4 / Group 9b).
 */
export function WelcomeHeader({ displayName, role }: WelcomeHeaderProps) {
	const badge = roleBadgeColors[role] ?? roleBadgeColors.VIEWER
	return (
		<div className="flex items-baseline gap-3">
			<h1 className="text-2xl font-semibold text-gray-900">Welcome, {displayName}</h1>
			<span className={`px-2 py-0.5 text-xs font-medium rounded ${badge}`}>{role}</span>
		</div>
	)
}
